import React, { useContext, useState } from "react";
import ReactGA from "react-ga4";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListSubheader from "@mui/material/ListSubheader";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import {
	Tools,
	Home,
	Menu2,
	ListDetails,
	Id,
	Search,
	ShoppingCart,
	Heart,
	Mail,
	CreditCard,
	UserCircle,
	Settings,
	DeviceMobileOff,
	Apps,
	LayoutList,
	Category,
	Qrcode,
	Lock,
	ClipboardText,
	ShoppingCartPlus,
	ListNumbers,
	News,
	Rocket,
	Power,
	Businessplan,
	CalendarEvent,
	CalendarTime,
	AddressBook,
	ColorSwatch,
	InfoCircle,
} from "tabler-icons-react";
import { makeStyles } from "@mui/styles";
import { UserContext } from "../../context/UserContext";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
	selected: {
		backgroundColor: "#43BD98",
		color: "#fff",
		"&:hover": {
			backgroundColor: "#43BD98!important",
			color: "#fff!important",
		},
	},
	selectedText: {
		color: "#fff",
	},
	menuItemText: {
		color: "#3C4856",
	},
});

export default function Menu({ drawerWidth, mobileOpen, handleDrawerToggle }) {
	const classes = useStyles();
	const navigate = useNavigate();
	const pathname = window.location.pathname;
	const { user } = useContext(UserContext);
	const { t } = useTranslation();

	const generalPages = (mobile) => [
		{
			name: t("menu.general"),
			icon: <Tools />,
			link: "/",
			id: "general",
		},
		{
			name: t("menu.qr"),
			icon: <Qrcode />,
			link: "/qr",
			id: "code" + (mobile ? "-mobile" : ""),
		},
		{
			name: t("menu.navigation"),
			icon: <Menu2 />,
			link: "/navigation",
			id: "navigation" + (mobile ? "-mobile" : ""),
		},
		{
			name: t("menu.fontsColor"),
			icon: <ColorSwatch />,
			link: "/colors",
			id: "appearance" + (mobile ? "-mobile" : ""),
		},
		{
			name: t("menu.pages"),
			icon: <Apps />,
			link: "/pages",
			id: "pages" + (mobile ? "-mobile" : ""),
		},
		{
			name: t("menu.placeholders"),
			icon: <ClipboardText />,
			link: "/placeholders",
		},
	];

	const generalPagesServices = (mobile) => [
		{
			name: t("menu.general"),
			icon: <Tools />,
			link: "/",
			id: "general",
		},
		{
			name: t("menu.qr"),
			icon: <Qrcode />,
			link: "/qr",
			id: "code",
		},
		{
			name: t("menu.navigation"),
			icon: <Menu2 />,
			link: "/navigation",
			id: "navigation" + (mobile ? "-mobile" : ""),
		},
		{
			name: t("menu.fontsColor"),
			icon: <ColorSwatch />,
			link: "/colors",
			id: "appearance" + (mobile ? "-mobile" : ""),
		},
		{
			name: t("menu.pages"),
			icon: <Apps />,
			link: "/pages",
			id: "pages",
		},
		{
			name: t("menu.bookingProcess"),
			icon: <CalendarEvent />,
			link: "/booking-process-services",
		},
		{
			name: t("menu.placeholders"),
			icon: <ClipboardText />,
			link: "/placeholders",
		},
	];

	const mainPages = (mobile) => [
		{
			name: t("menu.home"),
			icon: <Home />,
			link: "/home",
			id: "home" + (mobile ? "-mobile" : ""),
		},
		{
			name: t("menu.products"),
			icon: <ListDetails />,
			link: "/products",
		},
		{
			name: t("menu.productDetails"),
			icon: <Id />,
			link: "/product-details",
		},
		{
			name: t("menu.supercategories"),
			icon: <Category />,
			link: "/supercategories",
		},
		{
			name: t("menu.categories"),
			icon: <LayoutList />,
			link: "/categories",
		},
		{
			name: t("menu.search"),
			icon: <Search />,
			link: "/search",
		},
		{
			name: t("menu.cart"),
			icon: <ShoppingCart />,
			link: "/cart",
		},
		{
			name: t("menu.favorites"),
			icon: <Heart />,
			link: "/favorites",
		},
		{
			name: t("menu.contact"),
			icon: <Mail />,
			link: "/contact",
		},
		{
			name: t("menu.authentication"),
			icon: <Lock />,
			link: "/authentication",
		},
		{
			name: t("menu.loyalty"),
			icon: <CreditCard />,
			link: "/loyalty",
		},
		{
			name: t("menu.account"),
			icon: <UserCircle />,
			link: "/account",
		},
		{
			name: t("menu.orders"),
			icon: <ShoppingCartPlus />,
			link: "/orders",
		},
		{
			name: t("menu.orderDetails"),
			icon: <ListNumbers />,
			link: "/order-details",
		},
		{
			name: t("menu.news"),
			icon: <News />,
			link: "/news",
		},
	];

	const servicesPages = (mobile) => [
		{
			name: t("menu.home"),
			icon: <Home />,
			link: "/home-services",
			id: "home",
		},
		{
			name: t("menu.categories"),
			icon: <LayoutList />,
			link: "/categories-services",
		},
		{
			name: t("menu.services"),
			icon: <ListDetails />,
			link: "/services",
		},
		{
			name: t("menu.serviceDetails"),
			icon: <Id />,
			link: "/service-details",
		},
		{
			name: t("menu.calendar"),
			icon: <CalendarTime />,
			link: "/calendar",
		},
		{
			name: t("menu.yourAppointments"),
			icon: <AddressBook />,
			link: "/your-appointments",
		},
		{
			name: t("menu.news"),
			icon: <News />,
			link: "/news",
		},
		{
			name: t("menu.contact"),
			icon: <Mail />,
			link: "/contact",
		},
		{
			name: t("menu.authentication"),
			icon: <Lock />,
			link: "/authentication-service",
		},
		{
			name: t("menu.loyalty"),
			icon: <CreditCard />,
			link: "/loyalty",
		},
		{
			name: t("menu.account"),
			icon: <UserCircle />,
			link: "/account",
		},
	];

	const accountPages = (mobile) => [
		{
			name: t("menu.publish"),
			icon: <Rocket />,
			link: "/publish",
			id: "publish" + (mobile ? "-mobile" : ""),
		},
		{
			name: t("menu.meta"),
			icon: <InfoCircle />,
			link: "/metadata",
			id: "metadata",
		},
		{
			name: t("menu.profile"),
			icon: <Settings />,
			link: "/settings",
		},
		{
			name: t("menu.accountDeletion"),
			icon: <DeviceMobileOff />,
			link: "/account-deletion",
		},
		{
			name: t("menu.plans"),
			icon: <Businessplan />,
			link: "/plans",
		},
		{
			name: t("menu.logout"),
			icon: <Power />,
			onClick: () => {
				localStorage.removeItem("token");
				try {
					window.Tawk_API.logout(function (error) {
						// do something if error
					});
				} catch (error) {
					console.log(error);
				}
				window.location.reload();
			},
		},
	];

	const [showServices, setShowServices] = useState(
		user.app.appType === "Services"
	);

	const DrawerContent = (mobile) => {
		return (
			<>
				<Toolbar />
				<List>
					<ListSubheader sx={{ marginBottom: 1 }}>
						<Typography variant="h6">{t("menu.appSettings")}</Typography>
					</ListSubheader>
					{(showServices
						? generalPagesServices(mobile)
						: generalPages(mobile)
					).map((page, index) => (
						<ListItem
							key={page.name}
							disablePadding
							sx={{ cursor: "pointer" }}
							id={page.id}
							onClick={() => {
								navigate(page.link);
								if (mobile) {
									handleDrawerToggle();
								}
							}}
						>
							<ListItemButton
								className={
									pathname === page.link ? classes.selected : classes.menuItem
								}
							>
								<ListItemIcon
									sx={{
										maxWidth: 18,
										minWidth: 18,
										marginLeft: 2,
										marginRight: 1,
										opacity: 1,
									}}
									className={
										pathname === page.link
											? classes.selectedText
											: classes.menuItemText
									}
								>
									{page.icon}
								</ListItemIcon>
								<ListItemText disableTypography>
									<Typography
										sx={{
											fontWeight: 600,
											fontSize: 12,
											textDecoration: "none",
										}}
										className={
											pathname === page.link
												? classes.selectedText
												: classes.menuItemText
										}
									>
										{page.name}
									</Typography>
								</ListItemText>
							</ListItemButton>
						</ListItem>
					))}
				</List>
				<Divider sx={{ marginBottom: 1 }} />
				<List>
					<ListSubheader sx={{ marginBottom: 1 }}>
						<Typography variant="h6" id="pages-header">
							{t("menu.pages")}
						</Typography>
					</ListSubheader>
					{(showServices
						? servicesPages(mobile)
						: mainPages(mobile).filter(
								(p) =>
									(user.app.appType === "Woocommerce" &&
										p.type !== "Supercategories") ||
									user.app.appType !== "Woocommerce"
						  )
					).map((page, index) => (
						<ListItem
							id={page.id}
							key={page.name}
							onClick={() => {
								if (page.onClick) {
									page.onClick();
								} else {
									navigate(page.link);
								}
								if (mobile) {
									handleDrawerToggle();
								}
							}}
							disablePadding
						>
							<ListItemButton
								className={
									pathname === page.link ? classes.selected : classes.menuItem
								}
							>
								<ListItemIcon
									sx={{
										maxWidth: 18,
										minWidth: 18,
										marginLeft: 2,
										marginRight: 1,
										opacity: 1,
										color: "#3C4856",
									}}
									className={
										pathname === page.link
											? classes.selectedText
											: classes.menuItemText
									}
								>
									{page.icon}
								</ListItemIcon>
								<ListItemText disableTypography>
									<Typography
										sx={{
											fontWeight: 600,
											fontSize: 12,
											textDecoration: "none",
										}}
										className={
											pathname === page.link
												? classes.selectedText
												: classes.menuItemText
										}
									>
										{page.name}
									</Typography>
								</ListItemText>
							</ListItemButton>
						</ListItem>
					))}
				</List>
				<Divider sx={{ marginBottom: 1 }} />
				<List>
					<ListSubheader sx={{ marginBottom: 1 }}>
						<Typography variant="h6">{t("menu.account")}</Typography>
					</ListSubheader>
					{accountPages(mobile).map((page, index) => (
						<ListItem
							id={page.id}
							key={page.name}
							onClick={() => {
								if (page.onClick) {
									page.onClick();
								} else {
									navigate(page.link);
								}
								if (mobile) {
									handleDrawerToggle();
								}
							}}
							disablePadding
						>
							<ListItemButton
								className={
									pathname === page.link ? classes.selected : classes.menuItem
								}
							>
								<ListItemIcon
									sx={{
										maxWidth: 18,
										minWidth: 18,
										marginLeft: 2,
										marginRight: 1,
										opacity: 1,
										color: "#3C4856",
									}}
									className={
										pathname === page.link
											? classes.selectedText
											: classes.menuItemText
									}
								>
									{page.icon}
								</ListItemIcon>
								<ListItemText disableTypography>
									<Typography
										sx={{
											fontWeight: 600,
											fontSize: 12,
											textDecoration: "none",
										}}
										className={
											pathname === page.link
												? classes.selectedText
												: classes.menuItemText
										}
									>
										{page.name}
									</Typography>
								</ListItemText>
							</ListItemButton>
						</ListItem>
					))}
				</List>
				<Box sx={{ marginTop: 1, padding: 2 }}>
					<Button
						id="admin"
						variant="contained"
						sx={{ width: "100%" }}
						onClick={() => {
							ReactGA.event({
								category: "link",
								action: "click",
								label: "Go to admin", // optional
							});
							window.location.href =
								(window.location.hostname === "127.0.0.1"
									? "http://127.0.0.1:3001"
									: window.location.hostname === "localhost"
									? "http://localhost:3001"
									: "https://admin.applaby.com") +
								(localStorage.getItem("token")
									? "?session=" + localStorage.getItem("token")
									: "");
						}}
					>
						{t("menu.goToAdmin")}
					</Button>
				</Box>
			</>
		);
	};

	return (
		<>
			<Drawer
				variant="temporary"
				open={mobileOpen}
				color="secondary"
				onClose={handleDrawerToggle}
				ModalProps={{
					keepMounted: true, // Better open performance on mobile.
				}}
				sx={{
					display: { xs: "block", sm: "none" },
					"& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
				}}
			>
				{DrawerContent(true)}
			</Drawer>
			<Drawer
				variant="permanent"
				color="secondary"
				sx={{
					display: { xs: "none", sm: "block" },
					"& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
				}}
				open
			>
				{DrawerContent(false)}
			</Drawer>
		</>
	);
}
